import React from "react";
import { useDispatch } from "react-redux";
import { editActive, removeItem } from "../../features/items/itemsSlice";
import numberWithCommas from "../../utils/numberComma";
import deleteImage from "../../assets/images/delete.svg";
import editImage from "../../assets/images/edit.svg";
import Modal from "../Modal";

export default function Item({ item }) {
  const [showModal, setShowModal] = React.useState(false);
  const dispatch = useDispatch();
  const handleEdit = () => {
    setShowModal(true);
    dispatch(editActive(item));
  };
  const handleDelte = () => {
    dispatch(removeItem(item.id));
  };
  const { name, amount, type } = item;
  // console.log(item);
  return (
    <>
      {/* Modal */}
      {showModal ? <Modal setShowModal={setShowModal} /> : null}
      <li
        className={`transaction ${type === "income" ? "income" : "expense"} `}
      >
        <p>{name}</p>
        <div className="right">
          <p>৳ {numberWithCommas(amount)}</p>
          <button className="link" onClick={handleEdit}>
            <img alt="Edit" className="icon" src={editImage} />
          </button>
          <button className="link" onClick={handleDelte}>
            <img alt="Delete" className="icon" src={deleteImage} />
          </button>
        </div>
      </li>
    </>
  );
}
